import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => {
  const { typography, breakpoints, palette } = theme;
  const { pxToRem } = typography;
  return {
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    backDrop: {
      background: `${palette.common.black} 0% 0% no-repeat padding-box !important`,
      opacity: '0.19 !important'
    },
    paper: {
      backgroundColor: theme.palette.common.white,
      border: `1px solid ${palette.border}`,
      boxShadow: theme.shadows[1],
      padding: theme.spacing(2, 4, 3),
      minWidth: '20%'
    },
    buttonContainer: {
      textAlign: 'center',
      color: palette.text.button,
      [breakpoints.down('sm')]: {
        marginTop: pxToRem(10)
      }
    },
    buttonGrid: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      [breakpoints.down('sm')]: {
        flexDirection: 'column'
      }
    }
  };
});

export { useStyles };
